const ApiEndPoint = "https://my-json-server.typicode.com/artfuldev/json-db-data/";

export default ApiEndPoint;